import { Vault } from '@/features/vaults/types';
import { ETH_ERC_20, THQ_ETHEREUM } from '@/features/tokens/constants/tokens';
import { curators } from '@/features/vaults/curators';

export const EthereumTqethVaultId = 'ethereum-tqeth';
export const TheoriqAlphaVaultAddressEthereum = '0xDbC81B33A23375A90c8Ba4039d5738CB6f56fE8d';

export const EthereumTqethVault: Vault = {
  id: EthereumTqethVaultId,
  type: 'core-vault',
  name: 'Theoriq AlphaVault (ETH)',
  description:
    'Theoriq AlphaVault (ETH) accepts deposits in ETH, WETH, and wstETH, allocating them to on-chain ETH-denominated yield sources (currently Lido staking). Depositors receive tqETH, a wvault share token whose price per share reflects the vault’s net asset value and accrued rewards. Withdrawals can be requested in ETH or supported wrappers, with an expected ~2-day processing window. Over time, Theoriq will introduce bespoke agent-driven strategies and additional risk controls within predefined limits.',
  category: 'core-vault',
  address: TheoriqAlphaVaultAddressEthereum,
  curators: [curators.theoriq!.id],
  operator: [],
  tokenRewards: [
    {
      token: {
        network: 'ethereum',
        symbol: 'THQ',
        address: THQ_ETHEREUM,
        decimals: 18,
      },
      startTimestamp: 1745445600,
      startClaimTimestamp: 1745964000,
    },
  ],
  points: [{ entity: 'mellow', startTimestamp: 1738573595 }],
  network: 'ethereum',
  networks: [
    {
      network: 'ethereum',
      vaultAddress: TheoriqAlphaVaultAddressEthereum,
    },
  ],
  baseToken: ETH_ERC_20,
  lpTokenSymbol: 'tqETH',
  lpTokenDecimals: 18,
  oracleUpdateInterval: BigInt(86400),
  redeemHandlingInterval: BigInt(3600),
  allocations: {
    showAllocationsTab: true,
  },
};
